import clsx from 'clsx';
/* eslint-disable-next-line */
export interface TypographyProps {
    id?: string;
    value: string;
    variant?:
        | 'headline-1'
        | 'headline-2'
        | 'headline-3'
        | 'headline-4'
        | 'headline-5'
        | 'headline-6'
        | 'subtitle-1'
        | 'subtitle-2'
        | 'body-1'
        | 'body-2'
        | 'body-3'
        | 'button'
        | 'caption'
        | 'overline';
    font?: 'roboto' | 'poppins';
    className?: string;
}

export function Typography(props: TypographyProps) {
    const baseClasses = {
        'headline-1': 'text-5xl font-light tracking-wide',
        'headline-2': 'text-4xl',
        'headline-3': 'text-3xl',
        'headline-4': 'text-2xl',
        'headline-5': 'text-xl font-medium',
        'headline-6': 'text-lg font-medium',
        'subtitle-1': 'text-base font-medium',
        'subtitle-2': 'text-sm font-medium',
        'body-1': 'text-base',
        'body-2': 'text-sm',
        'body-3': 'text-xs',
        button: 'text-sm font-medium tracking-wider uppercase',
        caption: 'text-xs tracking-wide',
        overline: 'text-xss tracking-widest uppercase',
    };
    const classes = clsx(baseClasses[props.variant || 'body-1'], `font-${props.font}`, props.className);
    return (
        <p id={props.id} className={classes}>
            {props.value}
        </p>
    );
}

Typography.defaultProps = {
    variant: 'body-1',
    font: 'roboto',
};
export default Typography;
